PJQ.app.attachReadyEvent(function () {
	new PJQ.views.auth.SignIn({
		el: $('#pjq-login-main')
	});
});

PJQ.modules.signIn = {
	routes: [
		{
			route: 'login',
			name: 'login',
			callback: function () {
				new PJQ.views.auth.SignIn({
					el: $('#pjq-login-main')
				});
			}
		}
	]
};

PJQ.app.addRoutes(PJQ.modules.signIn.routes);